import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pop-up-dialog',
  templateUrl: './pop-up-dialog.component.html',
  styleUrls: ['./pop-up-dialog.component.less']
})
export class PopUpDialogComponent implements OnInit {
  showDismissButton: boolean = true;
  showConfirmButton: boolean = true;
  @Input() rows: string[];
  @Input() mode: string; // info, confirmation
  @Input() confirmButtonText: string;
  @Input() dismissButtonText: string;
  @Input() cancelButtonText: string;
  @Input() hideDismissButton: boolean;
  @Input() hideConfirmButton: boolean;
  @Input() showBulkNotifications: boolean = false;
  @Input() isBulkNotifications: boolean;
  @Input() bulkNotificationText: string;
  @Input() isLoading: boolean = false;

  @Output() confirmed = new EventEmitter();
  @Output() dismissed = new EventEmitter();
  @Output() cancelled = new EventEmitter();
  @Output() notify = new EventEmitter();

  texts: string[];
  confirmText: string;
  dismissText: string;
  enabled = true;


  constructor() {
  }

  ngOnInit() {
    if (this.hideConfirmButton) {
      this.showConfirmButton = false;
    }
    if (this.hideDismissButton) {
      this.showDismissButton = false;
    }

    if (!this.mode) {
      this.mode = 'confirmation';
    }
    if (!this.rows && this.mode === 'confirmation') {
      this.rows = ['Are you sure?'];
    }
    this.texts = this.rows;
    if (!this.confirmButtonText) {
      this.confirmButtonText = 'Confirm';
    }
    this.confirmText = this.confirmButtonText;

    if (!this.dismissButtonText) {
      this.dismissButtonText = 'Close';
    }
    this.dismissText = this.dismissButtonText;
  }

  dissmissButtonClick() {
    if (this.enabled) {
      this.enabled = false;
      this.dismissed.emit();
    }
  }

  confirmedButtonClick() {
    this.enabled = false;
    this.confirmed.emit();
  }

  cancelButtonClick() {
    this.cancelled.emit();
  }

  updateBulkNotifications(): void {
    this.notify.emit(this.isBulkNotifications);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/pop-up-dialog/pop-up-dialog.component.ts